import { Component, Input, OnInit } from '@angular/core';
import { Fase } from '../../_models/fase';
import { NavService } from '../../_services/_nav.service';
import { FaseEstado } from '../../_models/fase-estado';
import { ConfirmationService } from 'primeng/api';
import { FaseEstadoService } from '../../_services/fase-estado.service';
import { Rol } from '../../_models/rol';
import { Estado } from '../../_models/estado';
import { FaseEstadoRol } from '../../_models/fase-estado-rol';
import { EstadoService } from '../../_services/estado.service';
import { RolesService } from '../../_services/roles.service';
import { FaseEstadoRolService } from '../../_services/fase-estado-rol.service';
import { forkJoin } from 'rxjs';

@Component( {
  selector: 'app-fase-estado',
  templateUrl: 'fase-estado.component.html'
} )

export class FaseEstadoComponent implements OnInit {

  @Input() fase: Fase;
  columnas: any[];
  lisFaseEstado: FaseEstado[] = [];
  lisFaseEstadoTodos: FaseEstado[] = [];
  carInformacion = true;
  seccion = 'L';
  lisRoles: Rol[] = [];
  lisEstados: Estado[] = [];
  lisFaseRolTodos: FaseEstadoRol[] = [];
  fasEstadoSeleccionado: FaseEstado;

  constructor( private navServicio: NavService,
               private estServicio: EstadoService,
               private rolServicio: RolesService,
               private conServicio: ConfirmationService,
               private fasEstadoRolServicio: FaseEstadoRolService,
               private fasEstadoServicio: FaseEstadoService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'fase', header: this.navServicio.buscarMensaje( 'FASES.LBL_FASE' ), sort: true },
      { field: 'estado', header: this.navServicio.buscarMensaje( 'FASES.LBL_ESTADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.fasEstadoServicio.listadoPorFase( this.fase.idFase ),
      this.fasEstadoRolServicio.listadoPorFase( this.fase.idFase ),
      this.estServicio.listadoHabilitados(),
      this.rolServicio.listRolesEnabled() ).subscribe( ( [ listado, lisEstadoRol, lisEstados, lisRoles ] ) => {
      this.lisFaseEstadoTodos = listado;
      this.lisFaseRolTodos = lisEstadoRol;
      this.lisEstados = lisEstados;
      this.lisRoles = lisRoles;
      this.filtrarHabilitados();
      this.carInformacion = false;
    } );
  }

  filtrarHabilitados() {
    this.lisFaseEstado = this.lisFaseEstadoTodos.filter( x => x.indicadorHabilitado );
  }

  crear() {
    this.fasEstadoSeleccionado = null;
    this.seccion = 'E';
  }

  inhabilitar( registro: FaseEstado ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'fase-estado',
      accept: () => {
        this.carInformacion = true;
        registro.indicadorHabilitado = false;
        this.fasEstadoServicio.actualizar( registro ).subscribe( regActualizado => {
          this.actualizarRoles( registro );
        } );
      },
      reject: () => {
      }
    } );
  }

  actualizarRoles( registro: FaseEstado ) {
    const regActualizar = [];
    this.lisFaseRolTodos.map( ( s: FaseEstadoRol ) => {
      if ( s.indicadorHabilitado && s.idFaseEstado === registro.idFaseEstado ) {
        s.indicadorHabilitado = false;
        regActualizar.push( s );
      }
    } );
    if ( regActualizar.length > 0 ) {
      this.fasEstadoRolServicio.bulk( regActualizar ).subscribe( rta => {
        this.filtrarHabilitados();
        this.navServicio.setMesage( 2 );
        this.carInformacion = false;
      } );
    } else {
      this.filtrarHabilitados();
      this.navServicio.setMesage( 2 );
      this.carInformacion = false;
    }
  }

  editar( registro: FaseEstado ) {
    this.fasEstadoSeleccionado = registro;
    this.seccion = 'E';
  }

  cambiarSeccion() {
    this.filtrarHabilitados();
    this.seccion = 'L';
  }
}
